export default "__VITE_ASSET__BMiGItBl__"